import { PATCH_OPTIONS } from "./filter_options";

export const validParams = {
  builds: {
    patch: PATCH_OPTIONS,
    lane: [
      { value: "combined", label: "All Lanes" },
      { value: "single", label: "Solo Lane" },
      { value: "duo", label: "Duo Lane" },
    ],
  },
  tierList: {
    patch: PATCH_OPTIONS,
  },
};

export const global_exemptions = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "url",
  "gclid",
  "gtm",
  "google_preview",
  "gdfp_req",
  "lineItemId",
  "creativeId",
  "googfc",
  "iframe",
  "aps_debug",
  "aps_preview",
  "aps_pause",
  // for lngtd. Remove after they are done
  "krg_qa",
  "ad_id",
  "google_preview",
  "iu",
  "gdfp_req",
  "lineItemId",
  "creativeId",
  "testbidder",
];
